import {
  useEffect,
  useMemo
} from 'react';

import { useFolderQrCodeQuery } from 'generated/graphql';
import { appFormUtil } from 'modules/common';



type IFormState = {
  url: string;
  projectName: string;
  folderName: string;
};

const initialState: IFormState = {
  url: '',
  projectName: '',
  folderName: ''
};

export interface IData {
  folderName: string;
  projectName: string;
}

export function useQuery({
  folderId, url
}: {
  folderId: string;
  url: string;
}) {
  const {
    dispatch,
    formState
  } = appFormUtil.useFormState({
    initialState
  });

  const tuple = useFolderQrCodeQuery({
    skip: !folderId,
    variables: {
      folderId
    }
  });

  useEffect(() => {
    if (tuple.data && !tuple.loading && tuple.called) {
      dispatch({
        type: 'BATCH_UPDATE',
        payload: {
          folderName: tuple.data?.folder?.name ?? '',
          projectName: tuple.data?.folder?.project.name ?? '',
          url
        }
      });
    }
  }, [
    dispatch,
    tuple,
    url
  ]);

  return useMemo(
    () => {
      return {
        formState
      };
    }, [formState]
  );
}
